import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LockClockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lock_clock"}/>
}
